// extracted by mini-css-extract-plugin
module.exports = {"usersBlock":"Friends_usersBlock__2KCwF","bg":"Friends_bg__ifqJR","bgTitle":"Friends_bgTitle___nx3x","usersContainer":"Friends_usersContainer__2t5qw"};